import gql from 'graphql-tag'

export const GET_SUB_DOMAINS = gql`
  query DomainManagements($filter: DomainManagementFilter) {
    domainManagements(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      domainManagements {
        data {
          companyId
          companyName
          domainName
          vehicleTotal
          driverTotal
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
export const GET_DETAIL_SUB_DOMAIN = gql`
  query DetailDomainManagement($filter: DetailDomainManagementFilter) {
    detailDomainManagement(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      domainManagement {
        companyId
        companyName
        domainName
        email
        userId
      }
    }
  }
`

export const UPDATE_SUB_DOMAIN = gql`
  mutation UpdateDomainManagement($input: UpdateDomainManagement!) {
    updateDomainManagement(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      domainManagement {
        companyId
        companyName
        domainName
        email
        userId
      }
    }
  }
`
